import { ApiBase } from '../ApiBase';
class PlatformAppsApiClientModel extends ApiBase {
    constructor() {
        super(...arguments);
        this.getPlatformApps = () => {
            return this.get('/platformapps');
        };
        this.getPlatformApp = (id, redirectUri) => {
            return this.get(`/platformapps/${id}`, {
                redirectUri,
            });
        };
        this.connectPlatformApp = (id, body) => {
            return this.post(`/platformapps/${id}`, body);
        };
        this.disconnectPlatformApp = (id) => {
            return this.delete(`/platformapps/${id}`);
        };
    }
}
export const PlatformAppsApiClient = new PlatformAppsApiClientModel();
